import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
export default function usePatientManualRegistrationKDARFormValidationScheme() {
	const { t } = useTranslation();

	const validationSchema = yup.object({
		insuranceNumber: yup
			.string()
			.required(
				t('validation.patientManualRegistrationCzechForm.insuranceNumber'),
			),
		firstName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.firstName')),
		lastName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.lastName')),
		address: yup.object().shape({
			street: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.street'),
				),
			descriptiveNumber: yup
				.string()
				.required(
					t(
						'validation.patientManualRegistrationCzechForm.address.descriptiveNumber',
					),
				),
			guideNumber: yup.string().notRequired(),
			city: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.city'),
				),
			postCode: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.postCode'),
				),
		}),
		healthInsuranceCompany: yup.mixed().notRequired(),
		legalRepresentative: yup.object().shape({
			firstName: yup
				.string()
				.notRequired(),
			lastName: yup
				.string()
				.notRequired(),
			email: yup
				.string()
				.email(t('validation.patientManualRegistrationCzechForm.email'))
				.notRequired(),
			phoneNumber: yup.string().notRequired(),
		}),
		note: yup.string().notRequired(),
	});

	return { validationSchema };
}
